import { parseAsString, useQueryStates } from 'nuqs'

export function useServiceOAuthQueryState() {
  const [oauthParams, setOAuthParams] = useQueryStates({
    code: parseAsString.withDefault(''),
    state: parseAsString.withDefault(''),
    error: parseAsString.withDefault(''),
    error_description: parseAsString.withDefault(''),
    serviceId: parseAsString.withDefault(''),
  })
  const { code, state, error, error_description } = oauthParams

  return {
    oauthParams,
    setOAuthParams,
    isOAuthSuccess: !!(code && state),
    isOAuthError: !!(error || error_description),
  }
}
